// The wizard's fixed-shape inputs: a date of birth and a US phone number.
// The mask keeps typing honest; the screen validates the completed value.

import { PatternFormat } from "react-number-format";

import {
  FieldError,
  FieldHelper,
  FieldLabel,
  inputClass,
} from "components/FormV2/fields/chrome";

import type { WizardFieldProps } from "./WizardTextField";

const MASKS = {
  dob: {
    format: "##/##/####",
    placeholder: "MM/DD/YYYY",
    autoComplete: "bday",
    inputMode: "numeric",
    type: "text",
  },
  phone: {
    format: "(###) ###-####",
    placeholder: "(555) 555-5555",
    autoComplete: "tel-national",
    inputMode: "tel",
    type: "tel",
  },
} as const;

export default function WizardMaskedField({
  kind,
  id,
  label,
  value,
  onChange,
  error,
  helper,
  optional,
}: WizardFieldProps & { kind: keyof typeof MASKS }) {
  const mask = MASKS[kind];
  return (
    <div className="min-w-0">
      <FieldLabel text={label} htmlFor={id} optional={optional} />
      <PatternFormat
        id={id}
        name={id}
        type={mask.type}
        format={mask.format}
        placeholder={mask.placeholder}
        autoComplete={mask.autoComplete}
        inputMode={mask.inputMode}
        value={value}
        aria-invalid={error ? true : undefined}
        aria-describedby={error ? `${id}-error` : undefined}
        className={inputClass(Boolean(error))}
        onValueChange={(values, source) => {
          if (source.source === "event") onChange(values.formattedValue);
        }}
      />
      <FieldHelper text={helper} />
      <span id={`${id}-error`}>
        <FieldError message={error ?? undefined} />
      </span>
    </div>
  );
}
